import { ROLE_DEFINITIONS } from '../utils/constants';

export default function UploadSummary({ parsed }) {
  if (!parsed) return null;

  return (
    <div className="panel upload-summary">
      <div className="panel-header">
        <h3>Processing Summary</h3>
      </div>
      <div className="summary-grid">
        <div><span>Total rows found</span><strong>{parsed.totalRowsFound}</strong></div>
        <div><span>Valid rows imported</span><strong>{parsed.validRowsImported}</strong></div>
        <div><span>Skipped rows</span><strong>{parsed.skippedRows}</strong></div>
        <div><span>Date range found</span><strong>{parsed.minDate || '—'} to {parsed.maxDate || '—'}</strong></div>
        <div><span>Unique clients</span><strong>{parsed.uniqueClients}</strong></div>
        <div><span>Unique states</span><strong>{parsed.uniqueStates}</strong></div>
      </div>
      <h4>Unique team members per role</h4>
      <div className="summary-grid compact">
        {ROLE_DEFINITIONS.map((role) => (
          <div key={role.key}>
            <span>{role.label}</span>
            <strong>{parsed.uniqueTeamMembersByRole?.[role.key] ?? 0}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}
